var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"id":"contractor","grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"sm12":"","md6":""}},[_c('contractor-form',{attrs:{"width":"60%","contractorID":_vm.contractorID}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }